import { messages } from '../ui/messages';

// Bootstrap English from the descriptors until Traduki publishes this package's
// translations. The generated Traduki wrapper will replace this module.
const defaultMessages: Record<string, string> = Object.fromEntries(
	Object.values(messages).map(({ id, defaultMessage }) => [id, defaultMessage]),
);

export default defaultMessages;
